import { BaseModel } from '@Core';
import { Camera } from './Camera';
import { GroupPotentialContraventions } from './GroupPotentialContraventions';

export interface ContraventionProcessingJob extends BaseModel {
    CameraId: number;
    FromDate: Date;
    ToDate: Date;

    PotentialContraventions: number;

    CameraConfigs: ContraventionProcessingJobCameraConfig;

    Status?: ContraventionProcessingJobStatus;
    Desc?: string;

    Type?: ContraventionProcessingJobType;
    IsBackDateEnQueue?: boolean;
    GroupPotentialContraventions?: GroupPotentialContraventions[];
}

export interface ContraventionProcessingJobCameraConfig extends Camera {}

export enum ContraventionProcessingJobType {
    Backdate,
    Forecast,
}

export enum ContraventionProcessingJobStatus {
    Pending,
    InProgress,
    Completed,
    Failed,
    PartialCompleted,
}

export interface ContraventionProcessingJobGroupByOutCome extends ContraventionProcessingJob {
    PendingCount: number;
    ApprovedCount: number;
    CancelledCount: number;
    InProgressCount: number;
}
